// @flow
import * as React from 'react';

import TargetByStudentIdUploadPageContainer from './TargetByStudentIdUploadPageContainer';
import TargetByStudentIdUploadPageBody from './TargetByStudentIdUploadPageBody';

import type { ComposerOrganization } from 'reducers/roleBasedMessagingSearch';

type Props = {
  onUploadSuccess: (data: {
    studentIdListUuid: string,
    csvName: string,
  }) => void,
  onOrgSelection: (schoolUuid: string) => void,
  selectedSchoolUuid: string,
  onMount: () => void,
  schools: ?($Shape<ComposerOrganization>[]),
};

export default class TargetByStudentIdUploadPage extends React.Component<Props, *> {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    return (
      <TargetByStudentIdUploadPageContainer
        onUploadSuccess={this.props.onUploadSuccess}
        selectedSchoolUuid={this.props.selectedSchoolUuid}>
        {props => (
          <TargetByStudentIdUploadPageBody
            {...props}
            schools={this.props.schools}
            selectedSchoolUuid={this.props.selectedSchoolUuid}
            onOrgSelection={this.props.onOrgSelection}
          />
        )}
      </TargetByStudentIdUploadPageContainer>
    );
  }
}
